import Currencies from ".";

export const currencyRoutes = [
  {
    path: "/currencies",
    element: <Currencies />,
  },
];
